import React, { useEffect, useState } from "react";
import { Form, Input, Select, Button, Tooltip } from "antd";
import { createUserForm, updateUserForm } from "../../actions/admin";
import { useDispatch, useSelector } from "react-redux";
import { roleOptions } from "../../utils/comman";
import CustomPhoneNumber from "../../components/Comman/CustomPhoneNumber/CustomPhoneNumber";
import OrganizationListing from "../../components/Comman/DropdownsListing/OrganizationListing";
import ImageUpload from "../../components/Comman/ImageUpload";
import { RcFile } from "antd/es/upload";

const { Option } = Select;

interface SideDrawerProps {
  userData?: any; // Optional organization data
  open?: boolean;
  onClose?: any;
}

const CreateUser: React.FC<SideDrawerProps> = ({ userData, open, onClose }) => {
  const [form] = Form.useForm();
  const [logoUrl, setLogoUrl] = useState<string | null>(null);
  const loadingGlobal = useSelector((state: any) => state?.General);
  const [roleSpecifier, setRoleSpecifier] = useState(null);
  const [profilePhoto, setProfilePhoto] = useState<RcFile | null>(null);
  const dispatch: any = useDispatch();

  useEffect(() => {
    if (!open) {
      form.resetFields();
      setLogoUrl(null);
    }
  }, [open]);

  const onFinish = async (values: any) => {
    const formData = new FormData();

    // Ensure organizationId is always an array of strings
    const organizationId = Array.isArray(values.organizationId)
      ? values?.organizationId?.map(String)
      : [`${values?.organizationId}`];

    const payload = { ...values, organizationId: organizationId.join(",") };
    if (profilePhoto) {
      payload.profilePhoto = profilePhoto || null;
    }
    // Remove invalid profilePhoto values
    if ([null, undefined, "undefined"].includes(payload.profilePhoto)) {
      delete payload.profilePhoto;
    }
    // Remove sensitive fields before appending to formData
    if (userData) {
      delete payload.roleId;
      delete payload.email;
    }

    Object.keys(payload).forEach((key) => {
      const value = payload[key];
      if (![null, undefined, "", "undefined"].includes(value)) {
        formData.append(key, value);
      }
    });

    // Dispatch actions based on userData
    if (userData) {
      dispatch(
        updateUserForm({ id: userData.id, data: formData }, (resp: any) => {
          if (resp?.status === 200 || resp?.status === 201) {
            form.resetFields();
            onClose();
          }
        })
      );
    } else {
      dispatch(
        createUserForm(formData, (resp: any) => {
          if (resp?.status === 200 || resp?.status === 201) {
            form.resetFields();
            onClose();
          }
        })
      );
    }
  };

  const selectedRole =
    roleOptions?.find((role) => role?.id === userData?.roleId)?.name || "";

  // useEffect(() => {
  //   if (userData || (open && userData)) {
  //     setRoleSpecifier(userData?.roleId);
  //     // alert(selectedRole);
  //     form.setFieldsValue({
  //       firstName: userData?.firstName,
  //       lastName: userData?.lastName,
  //       email: userData?.email || "",
  //       mobileNumber: userData?.mobileNumber || "",
  //       roleId: selectedRole,
  //       profilePhoto: userData?.profilePhoto || null,
  //       ...(selectedRole !== "Admin" && {
  //         organizationId:
  //           userData?.organizationAssignment?.map(
  //             (org) => org.Organization_ID
  //           ) || [],
  //       }), // ✅ Extract and convert to string array
  //     });
  //     setLogoUrl(userData?.profilePhoto || null);
  //   } else {
  //     form.resetFields();
  //     setLogoUrl(null);
  //   }
  // }, [userData, open, form]);

  // ✅ Updated parent component useEffect
  useEffect(() => {
    if (userData || (open && userData)) {
      setRoleSpecifier(userData?.roleId);

      // ✅ Set form values with a small delay to ensure component is ready
      setTimeout(() => {
        form.setFieldsValue({
          firstName: userData?.firstName,
          lastName: userData?.lastName,
          email: userData?.email || "",
          mobileNumber: userData?.mobileNumber || "",
          roleId: selectedRole,
          profilePhoto: userData?.profilePhoto || null,
          ...(selectedRole !== "Admin" && {
            organizationId:
              userData?.organizationAssignment?.map(
                (org) => org.Organization_ID
              ) || [],
          }),
        });
      }, 100); // Small delay to ensure OrganizationListing is ready

      setLogoUrl(userData?.profilePhoto || null);
    } else {
      form.resetFields();
      setLogoUrl(null);
    }
  }, [userData, open, form, selectedRole]); // ✅ Added selectedRole dependency

  useEffect(() => {
    form.setFieldValue("organizationId", null);
  }, [roleSpecifier]);

  return (
    <Form form={form} layout="vertical" onFinish={onFinish} className="h-full">
      <div className="inner-drawer-wrapper flex flex-col h-full max-h-screen">
        <div className="upper-col flex-1">
          {/* <div className="mb-[20px]">
            <Tooltip title="User Name">
              <Form.Item
                name="name"
                rules={[
                  { required: true, message: "Please enter your username" },
                ]}
              >
                <Input
                  placeholder="User Name"
                  autoComplete="off" // ✅ Disables autofill
                  className="input-main-col focus:bg-transparent rounded-[5px] mb-[10px] p-[15px] border-1 border-transparent focus:border-white w-full bg-[#013351] placeholder-[#195A90] color-[#fff]"
                />  
              </Form.Item>
            </Tooltip>
          </div> */}
          <div className="mb-[20px]">
            <Tooltip title="First Name">
              <Form.Item
                name="firstName"
                rules={[
                  { required: true, message: "Please enter your first name" },
                ]}
              >
                <Input
                  placeholder="First Name"
                  autoComplete="off" // ✅ Disables autofill
                  className="input-main-col focus:bg-transparent rounded-[5px] mb-[10px] p-[15px] border-1 border-transparent focus:border-white w-full bg-[#013351] placeholder-[s] color-[#fff]"
                />
              </Form.Item>
            </Tooltip>
          </div>
          <div className="mb-[20px]">
            <Tooltip title="Last Name">
              <Form.Item
                name="lastName"
                rules={[
                  { required: true, message: "Please enter your last name" },
                ]}
              >
                <Input
                  placeholder="Last Name"
                  autoComplete="off" // ✅ Disables autofill
                  className="input-main-col focus:bg-transparent rounded-[5px] mb-[10px] p-[15px] border-1 border-transparent focus:border-white w-full bg-[#013351] placeholder-[#195A90] color-[#fff]"
                />
              </Form.Item>
            </Tooltip>
          </div>

          {/* {!userData && (
            <div className="mb-[20px]">
              <Tooltip title="Password">
                <Form.Item
                  name="password"
                  rules={[
                    { required: true, message: "Please enter your password!" },
                    {
                      min: 8,
                      message: "Password must be at least 8 characters!",
                    },
                    {
                      pattern:
                        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]+$/,
                      message:
                        "Password must include uppercase, lowercase, number, and special character!",
                    },
                  ]}
                >
                  <Input.Password
                    placeholder="Password"
                    autoComplete="off" // ✅ Disables autofill
                    className="input-main-col focus:bg-transparent rounded-[5px] mb-[10px] p-[15px] border-1 border-transparent focus:border-white w-full bg-[#013351] placeholder-[#195A90] color-[#fff]"
                  />
                </Form.Item>
              </Tooltip>
            </div>
          )} */}

          <div className="mb-[20px]">
            <Tooltip title="Email Address">
              <Form.Item
                name="email"
                rules={[
                  {
                    required: true,
                    type: "email",
                    message: "Please enter a valid email",
                  },
                ]}
              >
                <Input
                  placeholder="Email Address"
                  disabled={userData}
                  className="input-main-col focus:bg-transparent rounded-[5px] mb-[10px] p-[15px] border-1 border-transparent focus:border-white w-full bg-[#013351] placeholder-[#195A90] color-[#fff]"
                />
              </Form.Item>
            </Tooltip>
          </div>

          {/* <div className="mb-[20px]"> */}
          <ImageUpload
            logoUrl={logoUrl}
            imageName={"profilePhoto"}
            open={open}
            placeholder="Upload Profile Photo"
            onFileSelect={(file) => setProfilePhoto(file)}
          />

          {/* </div> */}
          {/* <div className="mb-[20px]"> */}
          <CustomPhoneNumber name="mobileNumber" />
          {/* </div> */}

          <div className="mb-[20px]">
            <Tooltip title="Role">
              <Form.Item
                name="roleId"
                rules={[{ required: true, message: "Please select a role" }]}
              >
                <Select
                  placeholder="Role"
                  // disabled
                  disabled={userData}
                  className="input-main-col focus:bg-transparent rounded-[5px] mb-[10px] p-[10px] border-1 border-transparent focus:border-white w-full bg-[#013351] placeholder-[#195A90] color-[#fff] h-auto"
                  value={selectedRole} // ✅ Set selected role name
                  onChange={(value) => {
                    setRoleSpecifier(value);
                  }}
                >
                  {roleOptions?.map((role) => (
                    <Option key={role.id} value={role.id}>
                      {role.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Tooltip>
          </div>
          {roleSpecifier !== 1 && userData?.roleId !== 1 && (
            <OrganizationListing
              dataToSet={userData}
              pageName={"createUser"}
              keyName={"organizationId"}
              idType="user"
              isReporting={true}
              userRole={roleSpecifier}
              open={open}
              // isReporting={roleSpecifier !== 4 ? true : false}
            />
          )}
        </div>
        <div className=" bottom-col">
          <Form.Item>
            <Button
              htmlType="submit"
              className="p-[25px] text-[12px] w-full text-white rounded-md gradient-button"
              loading={loadingGlobal?.isLoading}
            >
              {userData ? "Update" : "Submit"}
            </Button>
          </Form.Item>
        </div>
      </div>
    </Form>
  );
};

export default CreateUser;
